<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="!isAuthorizationLoading && isScreenAccessible; else skillSearchState"
  style="overflow: auto;">
  <div class="card">
    <div class="flex flex-column card-container">
      <div class="mb-1">
        <p-button *ngIf="showAddSkillButton" appPreventDoubleClick label="Add Skill" (debounceClick)="addSkill()"
          id="addSkillButton" class="add-skill-button" icon="fa fa-plus" iconPos="left"></p-button>
        <app-skill-creation-slider *ngIf="isSkillSliderOpen" [isSkillSliderOpen]="isSkillSliderOpen"
          (isSkillSliderActive)="closeSkillSlider($event)"></app-skill-creation-slider>
        <app-skill-search #librarySearch></app-skill-search>
      </div>
    </div>
  </div>
</div>
<ng-template #skillSearchState>
  <app-spinner *ngIf="isAuthorizationLoading"></app-spinner>
  <app-error *ngIf="!isAuthorizationLoading" [errorMessage]="errorMessage"></app-error>
</ng-template>